import React from 'react';
import { CSSObject } from '@emotion/react';
import useBreakpoints from '@hooks/useBreakpoints';
import { useTranslate } from 'nucleus-text';
import TextLink from '@cvent/carina/components/TextLink';
import Link from 'next/link';

interface InfoPageCallToActionProps {
  hasDescription: boolean;
  hasOnDemandContent: boolean;
  baseSessionsURL: string;
  hasSessionStartedOrEnded: boolean;
  disableJoinButton: boolean;
  viewSessionCallToAction: JSX.Element;
  onClickViewFullDetails: () => void;
}

const useStyles = ({ hasDescription = true, hasOnDemandContent = false }): Record<string, CSSObject> => {
  const { isMobile } = useBreakpoints();

  const callToActionMargin = isMobile ? 32 : 40;

  const showAlternateButtonConfiguration = !hasDescription && hasOnDemandContent;

  return {
    callToActionPostLoginButton: {
      marginRight: 20,
      marginBottom: showAlternateButtonConfiguration ? 24 : 0
    },
    callToActionPostLoginContainer: {
      display: 'flex',
      flexDirection: showAlternateButtonConfiguration ? 'column' : 'row',
      alignItems: 'center',
      marginTop: hasOnDemandContent || !hasDescription ? 0 : callToActionMargin,
      marginBottom: hasOnDemandContent && hasDescription ? 24 : 0,
      button: {
        svg: {
          marginLeft: 0
        }
      }
    },
    textLink: {
      textDecoration: 'underline'
    }
  };
};

function InfoPageCallToAction({
  hasDescription,
  hasOnDemandContent,
  baseSessionsURL,
  hasSessionStartedOrEnded,
  viewSessionCallToAction,
  disableJoinButton,
  onClickViewFullDetails
}: InfoPageCallToActionProps): JSX.Element {
  const { callToActionPostLoginContainer, callToActionPostLoginButton, textLink } = useStyles({
    hasDescription,
    hasOnDemandContent
  });
  const { translate } = useTranslate();

  return (
    <div css={callToActionPostLoginContainer}>
      {(hasSessionStartedOrEnded || disableJoinButton) && (
        <div css={callToActionPostLoginButton}>{viewSessionCallToAction}</div>
      )}
      <Link href={`${baseSessionsURL}`} passHref legacyBehavior>
        <TextLink onClick={onClickViewFullDetails} size="l" testID="view-full-details-button" css={textLink}>
          {translate('InfoPage-Webinar-Full-Details')}
        </TextLink>
      </Link>
    </div>
  );
}

export default InfoPageCallToAction;
